import { createRefPath, createRefPath_event } from '../../../global/firestoreData/appData/appRefPaths';
import { dispatchProps } from '../../../global/cnr/reducers/reducerHelpers/dispatchProps';
import { _settingsFs } from '../../../global/viewSettings/actions/getSettings';
import { settingsHelpers } from '../../../global/viewSettings/helpers/settingsHelpers';

export const _globalCollectionName = '_globals'
export const _dataLinksCollectionName = '_dataLinks'

export const updatePageItemDataFilter = (database_fns, isFilter, pathViews, viewItemKey, filterName, selectedFilters, dataRestrictions, dispatch) => {

  const settingsRoot = _settingsFs.root
  const baseSettingsName = settingsHelpers.getViewSettingsBaseName('events', pathViews)
  const _refPath = createRefPath([settingsRoot, baseSettingsName])

  const data = isFilter ?
    { viewItems: { [viewItemKey]: { dataFilters: { [filterName]: { filters: selectedFilters } } } } }
    :
    { viewItems: { [viewItemKey]: { dataFilters: { [filterName]: { filters: selectedFilters } } } } }

  if (dataRestrictions && (dataRestrictions.all || dataRestrictions.pageDataFilter)) {
    dispatch && dispatch({ type: dispatchProps.successAlt, dispatch })
    return true
  }

  console.log('_refPath', _refPath, data)
  // database_fns.set_doc(_refPath, data, true, dispatch)

}

/** adds (set) data to the `_globals` collection in the `globalName` doc */
export const updateGlobalDirect = (database_fns, pathViews, globalName, itemKey, itemData, callback) => {

  const subGlobal = globalName.substring(1)
  const _refPath = createRefPath_event(pathViews, [globalName, subGlobal])

  const dataToUpdate = {
    [subGlobal]: {
      [itemKey]: { ...itemData }
    }
  }

  database_fns.set_doc(_refPath, dataToUpdate, true, callback)

}

/** adds (set) data to the `_globals` collection in the `globalName` doc */
export const updateGlobal = (database_fns, pathViews, globalName, dataList, callback) => {
  const _refPath = createRefPath_event(pathViews, [_globalCollectionName, globalName])
  database_fns.set_doc(_refPath, dataList, true, callback)
}

/** adds (set) data to the `_globals` collection for each item in the `data` */
export const updateGlobals = (database_fns, pathViews, data) => {
  Object.keys(data).forEach(key => {
    const _refPath = createRefPath_event(pathViews, [_globalCollectionName, key])
    database_fns.set_doc(_refPath, data[key], true)
  })
} 